<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" :val="headerTitle" ref="header"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <div class="boxMsg bg02 hr">
          <p>미납 시 전문 상담원이 연락드릴 수 있으며, 90일 초과해 미납 시 계약 상실되어 채권추심을 위한 법무절차가 진행됩니다.</p>
        </div>
        <template v-if="showOrderAuthOverdueList == true">
          <section>
            <div class="titArea">
              <h2 class="titH4">미납내역</h2>
            </div>

            <div class="sortArea mt25 mb10">
              <div class="lcont">
                <span class="singleIpt">
                  <input type="checkbox" class="ipt" name="chkGroup0" id="chkAllBtn" v-model="chkAll" />
                  <label for="chkAllBtn">
                    <span class="normal txt">
                      전체선택 (
                      <i>{{ orderAuthOverdueList.length }}</i>
                      )
                    </span>
                  </label>
                </span>
              </div>
            </div>

            <div class="dataListWrap">
              <ul class="dataList">
                <li v-for="(orderAuthOverdue, orderAuthOverdueIndex) in orderAuthOverdueList" :key="orderAuthOverdueIndex">
                  <span class="singleIpt">
                    <input
                      type="checkbox"
                      class="ipt"
                      name="chkSub"
                      :id="'chkSub_' + orderAuthOverdueIndex"
                      :value="orderAuthOverdueIndex"
                      :overdueAmt="orderAuthOverdue.overdueAmounts"
                      @click="subCheck"
                      v-model="orderAuthOverdueCheck"
                    />
                    <label :for="'chkSub_' + orderAuthOverdueIndex">
                      <em>{{ orderAuthOverdue.orderId }} / {{ orderAuthOverdue.productName }}</em>
                    </label>
                  </span>
                  <div class="block">
                    <div class="info">
                      <span class="item">접수일</span>
                      <span class="val">{{ orderAuthOverdue.orderDate | dateFormatter('-') }}</span>
                    </div>
                    <div class="info">
                      <span class="item">주문번호</span>
                      <span class="val">{{ orderAuthOverdue.orderId }}</span>
                    </div>
                    <div class="info">
                      <span class="item">연체일수</span>
                      <span class="val">{{ orderAuthOverdue.overdueDays }}일</span>
                    </div>
                    <div class="info">
                      <span class="item">미납금액</span>
                      <span class="val">{{ orderAuthOverdue.overdueAmounts | currency }}원</span>
                    </div>
                  </div>
                  <div class="boxMsg ac pd0" v-if="orderAuthOverdue.overdueDays >= 60">
                    <p class="txtList_caution">고객님 연체일이 60일 이상 지났습니다.</p>
                  </div>
                </li>
              </ul>
            </div>
          </section>

          <section class="hr">
            <div class="titArea">
              <h2 class="titH4">결제금액</h2>
            </div>

            <div class="formArea" v-if="showInput">
              <div class="setBtnS">
                <input
                  type="tel"
                  class="ipt"
                  title="결제금액 입력"
                  data-unit="원"
                  placeholder=""
                  value=""
                  v-model="amountPayment"
                  @blur="validateAmount"
                />
                <button type="button" class="btn_g m" @click="totalAmount(true)">전액</button>
              </div>
              <div class="orderSum">
                <ul class="infoList">
                  <li>
                    <span class="item">잔여미납금액</span>
                    <span class="val">
                      <span class="money">
                        -
                        <span>{{ reUnpaidAmount | currency }}</span>
                        원
                      </span>
                    </span>
                  </li>
                </ul>
              </div>
              <p class="txtXS ar">
                [최소입금금액 : 월 렌탈료의 10%이상]
                <br />
                천원 단위로 결제 가능
              </p>
            </div>

            <div class="formArea" v-else>
              <div class="setBtnS">
                <input
                  type="tel"
                  class="ipt"
                  title="결제금액 입력"
                  data-unit="원"
                  placeholder=""
                  value=""
                  v-model="amountPayment"
                  readonly="readonly"
                />
                <button type="button" class="btn_g m" disabled="disabled">전액</button>
              </div>
              <div class="orderSum">
                <ul class="infoList">
                  <li>
                    <span class="item">잔여미납금액</span>
                    <span class="val">
                      <span class="money">
                        -
                        <span>{{ reUnpaidAmount | currency }}</span>
                        원
                      </span>
                    </span>
                  </li>
                </ul>
              </div>
              <p class="txtXS ar">총액 상환만 가능</p>
            </div>
          </section>

          <section class="hr">
            <div class="titArea">
              <h2 class="titH4">카드정보 입력</h2>
            </div>
            <div class="formArea">
              <span class="label">카드선택</span>
              <select v-on:input="changeCard($event.target.value)" v-model="cardName" name="card" class="ipt" title="카드선택">
                <option value="" disabled="disabled" selected="selected">선택해주세요</option>
                <option v-for="(card, index) in rcadCodeList" :value="card.code" :key="index">{{ card.codeName }}</option>
              </select>
              <p class="txtList_remark">본인 결제수단만 진행 가능</p>

              <span class="label">카드번호</span>
              <div class="transkey">
                <div class="setCard">
                  <input
                    type="tel"
                    id="cardNum1"
                    class="ipt"
                    maxlength="4"
                    title="카드번호 첫번째 4자리"
                    value=""
                    v-model="cardNum1"
                    v-onlyNum
                    nextTarget="cardNum2"
                    v-skipOfMax
                  />
                  <span class="sign" aria-hidden="true">-</span>
                  <input
                    type="tel"
                    id="cardNum2"
                    class="ipt"
                    maxlength="4"
                    title="카드번호 두번째 4자리"
                    value=""
                    v-model="cardNum2"
                    v-onlyNum
                    nextTarget="cardNum3"
                    v-skipOfMax
                  />
                  <span class="sign" aria-hidden="true">-</span>
                  <input
                    type="tel"
                    id="cardNum3"
                    class="ipt"
                    maxlength="4"
                    title="카드번호 세번째 4자리"
                    value=""
                    v-onlyNum
                    nextTarget="cardNum4"
                    data-tk-kbdType="number"
                    onfocus="mtk.onKeyboard(this); this.scrollIntoView();"
                  />
                  <span class="sign" aria-hidden="true">-</span>
                  <input
                    type="tel"
                    id="cardNum4"
                    class="ipt"
                    maxlength="4"
                    title="카드번호 마지막 4자리"
                    value=""
                    v-onlyNum
                    data-tk-kbdType="number"
                    onfocus="mtk.onKeyboard(this); this.scrollIntoView();"
                  />
                </div>
              </div>

              <span class="label">유효기간</span>
              <div class="transkey">
                <div class="setPeriod">
                  <input
                    type="tel"
                    id="expirdateMM"
                    nextTarget="expirdateYY"
                    class="ipt"
                    maxlength="2"
                    title="유효기간 월 2자리"
                    placeholder="MM"
                    v-onlyNum
                    data-tk-kbdType="number"
                    onfocus="mtk.onKeyboard(this); this.scrollIntoView();"
                  />
                  <span class="sign" aria-hidden="true">/</span>
                  <input
                    type="tel"
                    id="expirdateYY"
                    class="ipt"
                    maxlength="2"
                    title="유효기간 년 2자리"
                    placeholder="YY"
                    v-onlyNum
                    data-tk-kbdType="number"
                    onfocus="mtk.onKeyboard(this); this.scrollIntoView();"
                  />
                </div>
              </div>

              <span class="label">비밀번호</span>
              <div class="transkey">
                <div class="setPw">
                  <input
                    type="tel"
                    id="password"
                    class="ipt"
                    maxlength="2"
                    title="비밀번호 앞 2자리"
                    v-onlyNum
                    data-tk-kbdType="number"
                    onfocus="mtk.onKeyboard(this); this.scrollIntoView();"
                  />
                  <input type="password" class="ipt" maxlength="2" title="비밀번호 뒤 2자리" value="**" readonly="readonly" />
                </div>
              </div>

              <span class="label">생년월일</span>
              <div class="setBirth">
                <input
                  type="tel"
                  id="ssn1"
                  class="ipt"
                  maxlength="4"
                  title="생년월일 년도 4자리"
                  placeholder="1990"
                  v-model="ssn1"
                  v-onlyNum
                  nextTarget="ssn2"
                  v-skipOfMax
                />
                <span class="sign" aria-hidden="true">/</span>
                <input
                  type="tel"
                  id="ssn2"
                  class="ipt"
                  maxlength="2"
                  title="생년월일 월 2자리"
                  placeholder="01"
                  v-model="ssn2"
                  v-onlyNum
                  nextTarget="ssn3"
                  v-skipOfMax
                />
                <span class="sign" aria-hidden="true">/</span>
                <input type="tel" id="ssn3" class="ipt" maxlength="2" title="생년월일 일 2자리" placeholder="01" v-model="ssn3" v-onlyNum />
              </div>

              <p class="txtList_remark">
                미납금 결제건에 대한 청구금액 상세항목 및 결제내역 반영에는 전산 적용으로 인해 소정의 시간차가 있을 수 있습니다.
              </p>

              <span class="singleIpt">
                <input type="checkbox" class="ipt" id="chOk" />
                <label class="normal" for="chOk">
                  <span>
                    결제할 항목의 금액정보를 확인했으며 이에 동의합니다.
                    <br />
                    (전자상거래법 제8조2항)
                  </span>
                </label>
              </span>
            </div>
          </section>
          <div class="btnArea sticky">
            <button type="button" class="btn_p" @click="goPaymentComplete()" :disabled="duplicatePayCheck">결제하기</button>
          </div>
        </template>

        <template v-if="showOrderAuthOverdueList == false">
          <section>
            <div class="titArea">
              <h2 class="titH4">미납내역</h2>
            </div>

            <div class="resultMsg txtOnly">
              <p class="copy">미납금이 없습니다.</p>
            </div>
          </section>

          <!-- 미납 내역이 없을 경우(e) -->
          <CommonBanner></CommonBanner>
        </template>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>

    <MessagePop v-if="messagePop" @close="close">
      <p v-html="msg"></p>
      <template v-slot:bottomButtom v-if="this.messageType == 'paymentComplete'">
        <button type="button" class="btn_p" @click="paymentPopClose">확인</button>
      </template>
    </MessagePop>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
//import * as customjs from '@/../static/js/m.front.js';
import MessagePop from '@/components/popup/MessagePop';
import CommonBanner from '@/components/banner/CommonBanner';
import $ from 'jquery';
import { isEmpty } from '@/common/common.function';
import * as customjs from '@/../static/js/m.front.js';

export default {
  name: 'unPayment',
  data() {
    return {
      headerTitle: '미납금결제',
      msg: null,
      messagePop: false,
      messageType: '',

      chkAllBtn: false, // 전체동의
      chkAll: false,
      chkSub: [],
      showInput: true, // 결제금액 input
      duplicatePayCheck: false, // 결제 중복 체크

      amountPayment: 0, // 결제금액
      reUnpaidAmount: 0, // 잔여미납금액
      totalPrice: 0, // 미납총액

      orderAuthOverdueList: [],
      showOrderAuthOverdueList: false,
      rcadCodeList: [], // 카드 리스트
      cardName: '',
      cardNumber: '',
      cardExpireDate: '',
      ssn: '',

      orderAuthOverdueCheck: [], // 체크박스리스트

      cardNum1: null,
      cardNum2: null,
      cardNum3: null,
      cardNum4: null,
      expirdateMM: null,
      expirdateYY: null,
      cardPasswd: '',
      ssn1: null,
      ssn2: null,
      ssn3: null,
    };
  },
  components: {
    MessagePop,
    CommonBanner,
  },
  mounted() {
    this.selectOrderAuthOverdue();
    this.selectCommonCodeList();
  },
  updated() {
    customjs.init(); // TODO 확인필요

    $('.sortArea .lcont .singleIpt input:checkbox').bind({
      click: function (e) {
        if ($(this).prop('checked') == true) {
          $(this).parents('.sortArea').siblings('.dataListWrap').find('input:checkbox').prop('checked', true);
        } else {
          $(this).parents('.sortArea').siblings('.dataListWrap').find('input:checkbox').prop('checked', false);
        }
      },
    });
  },
  watch: {
    showOrderAuthOverdueList() {
      if (this.showOrderAuthOverdueList) {
        if (process.env.NODE_ENV != 'dev') {
          import('@/raon/welcomeTranskey').then((m) => {
            m.importCSS();
            m.importJS(0, ['cardNum3', 'cardNum4', 'expirdateMM', 'expirdateYY', 'password']);
          });
        }
      }
    },
    chkAll() {
      this.totalAmount(this.chkAll);
    },
    amountPayment() {
      this.reUnpaidAmount = this.totalPrice * 1 - this.amountPayment * 1;
      if (this.reUnpaidAmount == 0) {
        document.getElementById('chkAllBtn').checked = true;
      } else {
        document.getElementById('chkAllBtn').checked = false;
      }
    },
  },
  methods: {
    selectOrderAuthOverdue() {
      ApiService.service('GET', '/order/auth/overdue')
        .then(({ data }) => {
          this.orderAuthOverdueList = data.result;

          if (this.orderAuthOverdueList.length > 0) {
            this.showOrderAuthOverdueList = true;
            let totalPrice = 0;
            for (let i = 0; i < this.orderAuthOverdueList.length; i++) {
              totalPrice += this.orderAuthOverdueList[i].overdueAmounts * 1;
            }
            this.totalPrice = totalPrice;
          } else {
            this.showOrderAuthOverdueList = false;
          }
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    selectCommonCodeList() {
      ApiService.service('GET', '/common/code/RCAD')
        .then(({ data }) => {
          for (let value of data.result) {
            if (value.codePrefix === 'RCAD') {
              this.rcadCodeList = value.codeList;
            }
          }
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    changeCard: function (value) {
      this.cardName = value;
    },
    validateAmount() {
      const array_chkSub = document.getElementsByName('chkSub');
      for (let i = 0; i < array_chkSub.length; i++) {
        if (array_chkSub[i].checked) {
          this.orderAuthOverdueCheck.push(array_chkSub[i].value);
        }
      }

      if (this.orderAuthOverdueCheck.length === 0) {
        this.msg = '미납내역을 선택해주세요.';
        this.messagePop = true;
        this.messageType = '';
        return false;
      }
      if (this.orderAuthOverdueCheck.length === 1) {
        if (Number(this.orderAuthOverdueList[this.orderAuthOverdueCheck[0]].overdueAmounts) != Number(this.amountPayment)) {
          // const total = Number(this.orderAuthOverdueList[this.orderAuthOverdueCheck[0]].overdueAmounts);
          const taxAmount = this.orderAuthOverdueList[this.orderAuthOverdueCheck[0]].overdueAmounts * 1 * 0.1;

          if (this.amountPayment < taxAmount) {
            this.msg = '최소입금 금액은 월납입료의 10% 이상 금액으로 입금가능합니다.';
            this.messagePop = true;
            this.messageType = '';
            //this.amountPayment = 0;
            return false;
          } else if (this.amountPayment < 1000) {
            this.msg = `결제금액은 1천원 단위로 가능합니다.<br/>금액을 다시 확인해주세요.`;
            this.messagePop = true;
            this.messageType = '';
            return false;
          } else if (
            this.amountPayment.toString().substring(this.amountPayment.toString().length - 3, this.amountPayment.toString().length) !== '000'
          ) {
            this.msg = `결제금액은 1천원 단위로 가능합니다.<br/>금액을 다시 확인해주세요.`;
            this.messagePop = true;
            this.messageType = '';
            return false;
          }
        }
        if (Number(this.orderAuthOverdueList[this.orderAuthOverdueCheck[0]].overdueAmounts) < Number(this.amountPayment)) {
          this.msg = `결제금액이 잔여미납금액보다 큽니다.<br/>금액을 다시 확인해주세요.`;
          this.messagePop = true;
          this.messageType = '';
          return false;
        }
      }

      return true;
    },
    validate: function () {
      const valiCheck = this.validateAmount();
      if (valiCheck) {
        if (isEmpty(this.cardName)) {
          this.msg = '카드를 선택해주세요.';
          this.messagePop = true;
          this.messageType = '';
          return false;
        }
        if (isEmpty(this.cardNum1) || isEmpty(this.cardNum2)) {
          this.msg = '카드번호를 입력해주세요.';
          this.messagePop = true;
          this.messageType = '';
          return false;
        }
        /*  //TODO : 암호화 필드 유효성 체크 
          if (isEmpty(this.expirdateMM) || isEmpty(this.expirdateYY)) {
            this.msg = '유효기간을 입력해주세요.';
            this.messagePop = true;
            this.messageType = '';
            return false;
          }
          if (isEmpty(this.cardPasswd)) {
            this.msg = '비밀번호를 입력해주세요.';
            this.messagePop = true;
            this.messageType = '';
            return false;
          }*/
        if (isEmpty(this.ssn1) || isEmpty(this.ssn2) || isEmpty(this.ssn3)) {
          this.msg = '생년월일을 입력해주세요.';
          this.messagePop = true;
          this.messageType = '';
          return false;
        }

        const chOk = document.getElementById('chOk').checked;

        if (!chOk) {
          this.msg = '필수 동의 사항에 체크해주세요';
          this.messagePop = true;
          this.messageType = '';
          return false;
        }
        return true;
      }
      return false;
    },
    goPaymentComplete() {
      if (!this.validate()) {
        return;
      }
      if (this.duplicatePayCheck) {
        // 중복 결제 체크로직
        return;
      }
      this.duplicatePayCheck = true;
      this.cardNumber =
        process.env.NODE_ENV == 'dev'
          ? this.cardNum1 + this.cardNum2 + document.getElementById('cardNum3').value + document.getElementById('cardNum4').value
          : '';
      this.cardExpireDate = this.expirdateMM + '-' + this.expirdateYY;
      this.ssn = this.ssn1 + '' + this.ssn2 + '' + this.ssn3;

      let request = [];

      if ($("[id^='chkSub_']:checked").length > 1) {
        for (let i = 0; i < $("[id^='chkSub_']:checked").length; i++) {
          let idx = $("[id^='chkSub_']:checked:eq(" + i + ')').val();

          let requestChild = {
            orderId: this.orderAuthOverdueList[idx].orderId,
            payInfo: {
              birth: this.ssn,
              cardCode: this.cardName,
              encCardExpireMM: this.makeData('expirdateMM', 'Y'),
              encCardExpireYY: this.makeData('expirdateYY', 'Y'),
              cardNumber: this.cardNumber,
              cardNumber1: this.cardNum1,
              cardNumber2: this.cardNum2,
              encCardNumber3: this.makeData('cardNum3', 'Y'),
              encCardNumber4: this.makeData('cardNum4', 'Y'),
              monthInstPlan: 0,
              encPasswd: this.makeData('password', 'Y'),
              overdueDays: this.orderAuthOverdueList[idx].overdueDays,
              price: this.orderAuthOverdueList[idx].overdueAmounts,
              passwd: process.env.NODE_ENV == 'dev' ? document.getElementById('password').value : '',
              cardExpireYY: document.getElementById('expirdateYY').value,
              cardExpireMM: document.getElementById('expirdateMM').value,
            },
          };

          request.push(requestChild);
        }
      } else if ($("[id^='chkSub_']:checked").length === 1) {
        let requestChild = {
          orderId: this.orderAuthOverdueList[this.orderAuthOverdueCheck[0]].orderId,
          payInfo: {
            birth: this.ssn,
            cardCode: this.cardName,
            encCardExpireMM: this.makeData('expirdateMM', 'Y'),
            encCardExpireYY: this.makeData('expirdateYY', 'Y'),
            cardNumber: this.cardNumber,
            cardNumber1: this.cardNum1,
            cardNumber2: this.cardNum2,
            encCardNumber3: this.makeData('cardNum3', 'Y'),
            encCardNumber4: this.makeData('cardNum4', 'Y'),
            monthInstPlan: 0,
            encPasswd: this.makeData('password', 'Y'),
            overdueDays: this.orderAuthOverdueList[this.orderAuthOverdueCheck[0]].overdueDays,
            price: this.amountPayment,
            passwd: process.env.NODE_ENV == 'dev' ? document.getElementById('password').value : '',
            cardExpireYY: document.getElementById('expirdateYY').value,
            cardExpireMM: document.getElementById('expirdateMM').value,
          },
        };

        request.push(requestChild);
      }

      let reqParam = {
        request: request,
        serviceType: '',
      };
      this.$refs.header.loadingStart();
      ApiService.service('POST', '/order/auth/overdues/pay', reqParam)
        .then((response) => {
          if (response.data.isSucceed) {
            const params = {
              // af_order_id: reqParam.requestChild.orderId,
              // af_unpaid_day: reqParam.requestChild.overdueDays,
              af_order_id: request[0].orderId,
              af_unpaid_day: request[0].payInfo.overdueDays,
            };
            //const appsFlyerParams = JSON.stringify(params);
            window.appsFlyer('af_unpaid_pay', params);
            this.msg = '결제 완료되었습니다.';
            this.messagePop = true;
            this.messageType = 'paymentComplete';
          } else {
            if (response.data.result != null) {
              this.msg = response.data.result.resultMessage;
            } else {
              this.msg = response.data.error;
            }
            this.messagePop = true;
            this.messageType = '';
          }
        })
        .catch((response) => {
          console.log(response);
        })
        .finally(() => {
          this.$refs.header.loadingEnd();
        });
    },
    totalAmount(allCheckedYn) {
      this.chkAll = allCheckedYn;
      const array_chkSub = document.getElementsByName('chkSub');
      for (let i = 0; i < array_chkSub.length; i++) {
        array_chkSub[i].checked = allCheckedYn;
      }

      if (allCheckedYn) {
        this.amountPayment = this.totalPrice;
        this.reUnpaidAmount = 0;
        this.showInput = false;
      } else {
        this.amountPayment = 0;
        this.reUnpaidAmount = this.totalPrice;
        this.showInput = true;
      }
    },
    close() {
      this.messagePop = false;
      this.messageType = '';
    },
    paymentPopClose() {
      this.messagePop = false;
      this.$router.go(-1);
    },
    makeData(id, encrytedYN, plainValue) {
      if (process.env.NODE_ENV == 'dev') return null;
      // eslint-disable-next-line no-undef
      let values = mtk.inputFillEncData(document.getElementById(id));
      let name = document.getElementById(id).name;
      let hidden = values.hidden;
      let hmac = values.hmac;

      // eslint-disable-next-line no-undef
      let keyboardType = transkey[id].keyboard;
      // eslint-disable-next-line no-undef
      let keyIndex = transkey[id].keyIndex;
      // eslint-disable-next-line no-undef
      let fieldType = transkey[id].fieldType;
      let seedKey = document.getElementById('seedKey').value;
      let initTime = document.getElementById('initTime').value;
      let ExE2E = values.ExE2E;

      let newRaonRequest = {};
      newRaonRequest.id = id;
      newRaonRequest.name = name;
      newRaonRequest.keyboardType = keyboardType;
      newRaonRequest.keyIndex = keyIndex;
      newRaonRequest.fieldType = fieldType;
      newRaonRequest.seedKey = seedKey;
      newRaonRequest.initTime = initTime;
      newRaonRequest.transkey = hidden;
      newRaonRequest.transkey_HM = hmac.toString();
      newRaonRequest.transkey_EXE2E = ExE2E;
      newRaonRequest.plainValue = plainValue;
      newRaonRequest.encrytedYN = encrytedYN;

      return newRaonRequest;
    },
    subCheck() {
      let checkedPrice = 0;
      const array_chkSub = document.getElementsByName('chkSub');
      for (let i = 0; i < array_chkSub.length; i++) {
        if (array_chkSub[i].checked) {
          checkedPrice += array_chkSub[i].getAttribute('overdueAmt') * 1;
        }
      }

      if (this.totalPrice == checkedPrice) {
        this.showInput = false;
      } else {
        this.showInput = true;
      }
      this.amountPayment = checkedPrice;
    },
  },
};
</script>
